import { Box, Stack, Typography } from '@mui/material';
import MapComponent from '/@/components/map';
import { _ } from '/@/locale';
import FieldItem from './field-item';
import type { FieldSelectState } from './use-field-select';

type FieldSelectListAndMapProps = Pick<
    FieldSelectState,
    | 'fieldList'
    | 'field'
    | 'setField'
    | 'selectedProduct'
    | 'product'
    | 'showGrowersFields'
    | 'fieldRefs'
    | 'mapRef'
    | 'handleFieldClick'
    | 'fieldsQuery'
>;

function FieldSelectListAndMap({
    fieldList,
    field,
    setField,
    selectedProduct,
    product,
    showGrowersFields,
    fieldRefs,
    mapRef,
    handleFieldClick,
    fieldsQuery,
}: FieldSelectListAndMapProps) {
    return (
        <>
            <Stack height='100%' width='100%' sx={{ maxHeight: '500px', overflowY: 'auto' }}>
                {!!selectedProduct && (
                    <Stack direction='row' spacing={2} sx={{ py: 1 }} justifyContent='space-between'>
                        <Typography variant='caption' color='primary.mui.inactive' sx={{ pl: 8 }}>
                            {_('Lotes')}
                        </Typography>
                        <Typography variant='caption' color='primary.mui.inactive' sx={{ pr: 2 }}>
                            {_('Rendimiento estimado')} {product?.catalogName}
                        </Typography>
                    </Stack>
                )}
                {fieldList.map((f, i) => (
                    <div key={f.id} ref={(el) => (fieldRefs.current[f.id] = el)}>
                        <FieldItem
                            field={f}
                            fieldIsSelected={field?.id === f.id}
                            setSelectedField={setField}
                            dataTestId={`field-item-${i}`}
                            showGrowerLabel={showGrowersFields}
                        />
                    </div>
                ))}
            </Stack>
            {fieldList.length && !fieldsQuery.isLoading ? (
                <Box height='100%' width='100%' sx={{ position: 'relative' }} minHeight='350px'>
                    <MapComponent
                        ref={mapRef}
                        fields={fieldList}
                        onFieldClick={handleFieldClick}
                        offline={false}
                        noGeocoder
                        simplifyPolygons
                        field={field}
                    />
                </Box>
            ) : null}
        </>
    );
}

export default FieldSelectListAndMap;
